/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from 'theme-ui';

import CardPortrait from './CardPortrait';
import ListWrap from './ListWrap';

import { getBookAuthors, getBookSlug, getBookTitle } from '../selectors';

export default function ListPortrait({ books, cap = 999, heading, route }) {
  return (
    <ListWrap heading={heading} route={route} length={books.length}>
      {books.map((book, index) => {
        const { title, subtitle } = book;
        const bookTitle = getBookTitle({ title, subtitle });
        const authors = getBookAuthors(book.authors);
        const slug = getBookSlug(book);
        if (index < cap) {
          return (
            <CardPortrait
              authors={authors}
              key={book.id}
              thumbnail={book.imageLinks.thumbnail}
              title={bookTitle}
              slug={slug}
            />
          );
        }
        return null;
      })}
    </ListWrap>
  );
}
